import { Record } from 'immutable';
import {
  MutationEffect,
  MutationError,
  MutationRequest,
  MutationSuccess,
} from 'src/util/graphql/mutation-actions';

export class MutationStatus extends Record({
  request: null as any,
  success: null as any,
  effect: null as any,
  error: null as any,
}) {
  public request: MutationRequest;
  public success: MutationSuccess | null;
  public error: MutationError | null;
  public effect: MutationEffect | null;

  get operationId() {
    return this.request.operationId;
  }

  get isSuccess() {
    return this.success != null;
  }

  get isError() {
    return this.error != null;
  }

  get isRequestComplete() {
    return this.isError || this.isSuccess;
  }

  get hasEffect() {
    return this.effect != null;
  }

  get effectTime() {
    return this.effect != null ? this.effect.timestamp : null;
  }

  get startTime() {
    return this.request.timestamp;
  }

  get effectDuration() {
    if (this.effectTime != null) {
      return this.effectTime - this.startTime;
    }
    return null;
  }

  constructor(request: MutationRequest) {
    super({ request });
  }
}
